import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';

import { popIn, staggerIn } from '@app/animations';
import * as rolesUtils from '@app/role.utils';

@Component({
  selector: 'app-products-list',
  templateUrl: './products-list.component.html',
  styleUrls: ['./products-list.component.css'],
  animations: [staggerIn, popIn],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductsListComponent implements OnInit {
  @Input()
  products;

  @Input()
  selectedProducts;

  @Input()
  drillDown;

  @Input()
  role;

  @Input()
  countryDepartments;

  @Output()
  selected = new EventEmitter();

  checkboxes = {};
  countryDepartmentsRed;

  openL3s = {};
  openParents = {};
  openDeps = {};
  openCodes = {};
  openGrandParent = {};
  selectionAll = false;

  get isCountryBuyer() {
    if (this.selectedProducts.length === 0) {
      this.selectionAll = false;
    }
    return this.role && this.role && rolesUtils.isCountryUser(this.role);
  }

  constructor() {}

  ngOnInit() {}

  toggleSelected({ id, metaKey, shiftKey }) {
    if (metaKey && !shiftKey) {
      if (this.isSelected(id)) {
        this.selected.emit(
          this.selectedProducts.map(p => p.id).filter(i => i !== id)
        );
      } else {
        this.selected.emit([...this.selectedProducts.map(p => p.id), id]);
      }
    } else if (!metaKey && shiftKey) {
      if (this.selectedProducts && this.selectedProducts.length) {
        let mapped = [];
        if (!this.isCountryBuyer) {
          const l3s = Object.keys(this.drillDown);
          for (let i = 0, l3sLength = l3s.length; i < l3sLength; i++) {
            const l3 = this.drillDown[l3s[i]];
            const l4s = Object.keys(l3);
            for (let j = 0, l4sLength = l4s.length; j < l4sLength; j++) {
              const l4 = l3[l4s[j]];
              const l5s = Object.keys(l4);
              for (let k = 0, l5sLength = l5s.length; k < l5sLength; k++) {
                const l5 = l4[l5s[k]];
                const mainCodes = Object.keys(l5);
                for (
                  let l = 0, mainCodesLength = mainCodes.length;
                  l < mainCodesLength;
                  l++
                ) {
                  const mainCode = l5[mainCodes[l]];
                  mapped = [...mapped, ...mainCode.map(product => product.id)];
                }
              }
            }
          }
        } else {
          const mainCodes = Object.keys(this.drillDown);
          for (
            let l = 0, mainCodesLength = mainCodes.length;
            l < mainCodesLength;
            l++
          ) {
            const mainCode = this.drillDown[mainCodes[l]];
            mapped = [...mapped, ...mainCode.map(product => product.id)];
          }
        }

        const start = mapped.indexOf(this.selectedProducts[0].id);
        const end = mapped.indexOf(id);

        let tempSelection;
        if (start > end) {
          tempSelection = [...mapped].slice(end, start + 1).reverse();
        } else {
          tempSelection = mapped.slice(start, end + 1);
        }
        this.selected.emit(tempSelection);
      }
    } else {
      if (
        (this.isSelected(id) && this.selectedProducts.length > 1) ||
        !this.isSelected(id)
      ) {
        this.selected.emit([id]);
      } else {
        this.selected.emit([]);
      }
    }
  }

  isSelected(id) {
    return this.selectedProducts.map(p => p.id).includes(id);
  }

  trackByFn(index, item) {
    return item.code;
  }

  trackMainCodeFn(index, item) {
    return item.key;
  }

  trackDepartmentFn(index, item) {
    return item.key;
  }

  selectAll(checked) {
    if (checked) {
      const mapped = this.products.map(p => p.id);
      this.selected.emit(mapped);
      this.selectionAll = true
    } else {
      this.selectionAll = false
      this.selected.emit([]);
    }
  }

  checkIndetermined(key) {
    let mapped = [];
    const [l3Key, l4Key, l5Key, mainCodeKey] = key;
    const l3s = Object.keys(this.drillDown).filter(l3 => l3 === l3Key);
    for (let i = 0, l3sLength = l3s.length; i < l3sLength; i++) {
      const l3 = this.drillDown[l3s[i]];
      const l4s = Object.keys(l3).filter(l4 => (l4Key ? l4 === l4Key : true));
      for (let j = 0, l4sLength = l4s.length; j < l4sLength; j++) {
        const l4 = l3[l4s[j]];
        const l5s = Object.keys(l4).filter(l5 => (l5Key ? l5 === l5Key : true));
        for (let k = 0, l5sLength = l5s.length; k < l5sLength; k++) {
          const l5 = l4[l5s[k]];
          const mainCodes = Object.keys(l5).filter(mainCode =>
            mainCodeKey ? mainCode === mainCodeKey : true
          );
          for (
            let l = 0, mainCodesLength = mainCodes.length;
            l < mainCodesLength;
            l++
          ) {
            const mainCode = l5[mainCodes[l]];
            mapped = [...mapped, ...mainCode.map(product => product.id)];
          }
        }
      }
    }
    const ids = this.selectedProducts.map(p => p.id);
    return (
      !mapped.every(id => ids.includes(id)) &&
      mapped.some(id => ids.includes(id))
    );
  }

  checkChecked(key) {
    let mapped = [];
    const [l3Key, l4Key, l5Key, mainCodeKey] = key;
    const l3s = Object.keys(this.drillDown).filter(l3 => l3 === l3Key);
    for (let i = 0, l3sLength = l3s.length; i < l3sLength; i++) {
      const l3 = this.drillDown[l3s[i]];
      const l4s = Object.keys(l3).filter(l4 => (l4Key ? l4 === l4Key : true));
      for (let j = 0, l4sLength = l4s.length; j < l4sLength; j++) {
        const l4 = l3[l4s[j]];
        const l5s = Object.keys(l4).filter(l5 => (l5Key ? l5 === l5Key : true));
        for (let k = 0, l5sLength = l5s.length; k < l5sLength; k++) {
          const l5 = l4[l5s[k]];
          const mainCodes = Object.keys(l5).filter(mainCode =>
            mainCodeKey ? mainCode === mainCodeKey : true
          );
          for (
            let l = 0, mainCodesLength = mainCodes.length;
            l < mainCodesLength;
            l++
          ) {
            const mainCode = l5[mainCodes[l]];
            mapped = [...mapped, ...mainCode.map(product => product.id)];
          }
        }
      }
    }
    const ids = this.selectedProducts.map(p => p.id);
    return mapped.every(id => ids.includes(id));
  }

  treeSelection(key, event) {
    const state = event.target.checked;
    let mapped = [];
    const [l3Key, l4Key, l5Key, mainCodeKey] = key;
    const l3s = Object.keys(this.drillDown).filter(l3 => l3 === l3Key);
    for (let i = 0, l3sLength = l3s.length; i < l3sLength; i++) {
      const l3 = this.drillDown[l3s[i]];
      const l4s = Object.keys(l3).filter(l4 => (l4Key ? l4 === l4Key : true));
      for (let j = 0, l4sLength = l4s.length; j < l4sLength; j++) {
        const l4 = l3[l4s[j]];
        const l5s = Object.keys(l4).filter(l5 => (l5Key ? l5 === l5Key : true));
        for (let k = 0, l5sLength = l5s.length; k < l5sLength; k++) {
          const l5 = l4[l5s[k]];
          const mainCodes = Object.keys(l5).filter(mainCode =>
            mainCodeKey ? mainCode === mainCodeKey : true
          );
          for (
            let l = 0, mainCodesLength = mainCodes.length;
            l < mainCodesLength;
            l++
          ) {
            const mainCode = l5[mainCodes[l]];
            mapped = [...mapped, ...mainCode.map(product => product.id)];
          }
        }
      }
    }

    const ids = this.selectedProducts.map(p => p.id);
    if (state) {
      this.selected.emit([...ids, ...mapped.filter(id => !ids.includes(id))]);
    } else {
      this.selected.emit(ids.filter(id => !mapped.includes(id)));
    }
  }

  nameDepartment(id) {
    // console.log('list', this.countryDepartments);
    this.countryDepartmentsRed = this.countryDepartments.reduce((acc, cp) => {
      acc[cp.id] = cp.name;

      return acc;
    }, {});

    return this.countryDepartmentsRed[id];
  }

  test() {
    console.log('-----', this.openDeps);
  }
}
